// import { Fullscreen } from "@mui/icons-material";
import { FullscreenOutlined } from '@mui/icons-material';
import { Button, Tooltip } from 'antd';

interface Props {
  isActive: boolean;
  onClick: () => void;
}

export const FullScreenButton: React.FC<Props> = (props) => {
  const { isActive, onClick } = props;

  return (
    <Tooltip title={'FullScreen'}>
      <Button
        type={'text'}
        className={isActive ? 'tw-bg-[#bdbcbc] hover:!tw-bg-[#bdbcbc]' : ''}
        icon={<FullscreenOutlined />}
        onClick={onClick}
      />
    </Tooltip>
  );
};
